import { parseCookies, setCookie, destroyCookie } from 'nookies'
import { LOCALE_COOKIE, LOCALE_COOKIE_MAX_AGE, SESSION_TIMEOUT } from '@/lib/constants'
import { GetServerSidePropsContext } from 'next'
import { isEmbeddedFrame } from '@/utils/frameUtil'
import { getProfileLocale, LanguageCode } from '@/utils/languageUtil'

// we keep this flag in a cookie to determine
// on a ssr if a user is logged in
export const storeAuthCookie = () => {
  setCookie({}, 'isAuth', 'true', {
    maxAge: SESSION_TIMEOUT,
    path: '/',
    secure: true,
    sameSite: isEmbeddedFrame() ? 'none' : 'lax',
  })
}

export const destroyAuthCookie = () => {
  destroyCookie({}, 'isAuth', { path: '/' })
}

export const fetchAuthCookie = (ctx?: GetServerSidePropsContext) => {
  const cookies = parseCookies(ctx)
  return cookies.isAuth || null
}

export const extendAuthCookie = (ctx?: GetServerSidePropsContext) => {
  const authCookieStr = fetchAuthCookie(ctx as unknown as GetServerSidePropsContext)
  if (authCookieStr) {
    storeAuthCookie()
    return true
  }
  return false
}

/**
 * Records an explicit language choice; the middleware lets it outrank the browser's Accept-Language.
 * @param locale - A supported locale code.
 */
export const storeLocaleCookie = (locale: LanguageCode) => {
  setCookie({}, LOCALE_COOKIE, locale, {
    maxAge: LOCALE_COOKIE_MAX_AGE,
    path: '/',
    secure: true,
    sameSite: isEmbeddedFrame() ? 'none' : 'lax',
  })
}

/**
 * Forgets the language choice so the browser's Accept-Language applies again.
 */
export const destroyLocaleCookie = () => {
  destroyCookie({}, LOCALE_COOKIE, { path: '/' })
}

/**
 * Called at login only: sets the cookie to the user's saved language, or clears one a previous user left behind.
 * @param profile - The user fetched at login.
 */
export const syncLocaleCookie = (profile?: { language?: string | null } | null) => {
  const locale = getProfileLocale(profile)
  if (locale) {
    storeLocaleCookie(locale)
  } else {
    destroyLocaleCookie()
  }
}
